import React, { useEffect } from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import SummarycomponetWithPayment from "../component/User/Summary/SummarycomponetWithPayment.jsx"
const SummaryPageWithPayment = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);

  return (
  <>
  <Header/>
  <SummarycomponetWithPayment/>
  <Footer/>
  </>
  )
}

export default SummaryPageWithPayment